module.exports = __webpack_public_path__ + "static/apply_bg-78dd6c644bda8c62ba5ce9386d043aac.jpg";